<app-all-leads-filter (sortChange)="$event ? sortByDistance() : defaultSort()"/>
<mat-card class="card">

  <table
    mat-table
    [dataSource]="tableDataSource"
    data-testid="all-leads-list-table"
  >
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>
        {{ "components.all-leads-list.table.name" | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let lead"
        (click)="toggleLead(lead)"
        (keyup)="toggleLead(lead)"
        tabindex="-1"
      >
        {{ lead.name }}
      </td>
    </ng-container>
    <!-- combined column to display postalCode and city on tiny displays -->
    <ng-container matColumnDef="postalCodeCity">
      <th mat-header-cell *matHeaderCellDef>
        {{ "components.all-leads-list.table.postalCode" | translate }} /
        {{ "components.all-leads-list.table.city" | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let lead"
        (click)="toggleLead(lead)"
        (keyup)="toggleLead(lead)"
        tabindex="-1"
      >
        <div style="display: block">{{ lead.address.postalCode }}</div>
        <div style="display: block">{{ lead.address.city }}</div>
      </td>
    </ng-container>
    <ng-container matColumnDef="postalCode">
      <th mat-header-cell *matHeaderCellDef>
        {{ "components.all-leads-list.table.postalCode" | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let lead"
        (click)="toggleLead(lead)"
        (keyup)="toggleLead(lead)"
        tabindex="-1"
      >
        {{ lead.address.postalCode }}
      </td>
    </ng-container>
    <ng-container matColumnDef="city">
      <th mat-header-cell *matHeaderCellDef>
        {{ "components.all-leads-list.table.city" | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let lead"
        (click)="toggleLead(lead)"
        (keyup)="toggleLead(lead)"
        tabindex="-1"
      >
        {{ lead.address.city }}
      </td>
    </ng-container>
    <ng-container matColumnDef="priority">
      <th mat-header-cell *matHeaderCellDef>
        {{ "components.all-leads-list.table.priority" | translate }}
      </th>
      <td mat-cell *matCellDef="let lead">
        {{ "enums.priority." + lead.priority | translate }}
      </td>
    </ng-container>
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          (change)="$event ? toggleAllRows() : null"
          [checked]="isAnySelected() && isAllSelected()"
          [indeterminate]="isAnySelected() && !isAllSelected()"
        >
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let lead">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? toggleLead(lead) : null"
          [checked]="leadService.isSelected(lead.id)"
        >
        </mat-checkbox>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
  </table>

  <mat-paginator
    [pageSizeOptions]="[5, 10, 20, 50]"
    [pageSize]="10"
    aria-label="Select page"
  ></mat-paginator>

</mat-card>
